import XIcon from "@mui/icons-material/Close"
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  Divider,
  IconButton,
  Stack,
  Typography,
} from "@mui/material"
import { DialogProps } from "@/dialogs"
import { useForm } from "react-hook-form"
import { zodResolver } from "@hookform/resolvers/zod"
import { z } from "zod"
import ControlledTextInput from "@/components/controlledInputs/ControlledTextInput"
import ControlledDatePicker from "@/components/controlledInputs/ControlledDatePIcker"

interface RecommendEventDialog extends DialogProps {}

const recommendFormSchema = z.object({
  name: z.string(),
  email: z.string(),
  date: z.string(),
  time: z.string(),
  location: z.string(),
  category: z.string(),
  ageRange: z.string(),
  price: z.string(),
  link: z.string(),
  description: z.string(),
})
export type RecommendFormDataType = z.infer<typeof recommendFormSchema>
const defaultValues: RecommendFormDataType = {
  name: "",
  email: "",
  date: "",
  time: "",
  location: "",
  category: "",
  ageRange: "",
  price: "",
  link: "",
  description: "",
}

export default function RecommendEventDialog({
  isOpen,
  closeDialog,
}: RecommendEventDialog) {
  function handleClose() {
    closeDialog()
  }

  const {
    // handleSubmit,
    // reset,
    control,
    // setValue,
    // formState: { errors },
  } = useForm<RecommendFormDataType>({
    resolver: zodResolver(recommendFormSchema),
    defaultValues: defaultValues,
  })
  return (
    <Dialog open={isOpen} onClose={handleClose}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        minWidth={"500px"}
        pl={3}
        pr={1}
        py={1}
        sx={{
          backgroundColor: "white",
          color: "black",
        }}
      >
        <Typography>Recommend An Event</Typography>
        <Box>
          <IconButton color="inherit" onClick={handleClose}>
            <XIcon />
          </IconButton>
        </Box>
      </Stack>
      <DialogContent
        sx={{
          py: 2,
        }}
      >
        <form action="https://formsubmit.co/info@843hub.com" method="POST">
          <Typography>
            Are we missing something? Fill us in! Recommend a local event to the
            843 community.
          </Typography>
          <Divider sx={{ padding: 2 }} />
          <Typography sx={{ pt: 2 }}>Event Info:</Typography>
          <Box
            display="flex"
            flexDirection="row"
            justifyContent="space-between"
          >
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="name"
                label="Name"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="email"
                label="Email"
                variant="filled"
              />
              <ControlledDatePicker
                control={control}
                name="date"
                label="Date"
                //   variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="time"
                label="Time"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="location"
                label="Location"
                variant="filled"
              />
            </Stack>
            <Stack spacing={2} pt={2}>
              <ControlledTextInput
                control={control}
                name="category"
                label="Category"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="ageRange"
                label="Age Range"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="price"
                label="Price"
                variant="filled"
              />
              <ControlledTextInput
                control={control}
                name="link"
                label="Link"
                variant="filled"
              />
            </Stack>
          </Box>
          <Divider sx={{ paddingTop: 2 }} />
          <Stack
            direction="row"
            justifyContent="space-between"
            spacing={2}
            mt={3}
          >
            <Button variant="text" color="inherit" onClick={closeDialog}>
              Cancel
            </Button>

            <Button
              variant="contained"
              color="primary"
              type="submit"
              onClick={() => {
                closeDialog()
              }}
            >
              Send
            </Button>
          </Stack>
        </form>
      </DialogContent>
    </Dialog>
  )
}
